import testService from 'ApiService/Teacher/TestService';
import Card from 'components/card';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import StepperControl from 'views/admin/main/users/newUser/components/Admissions/StepperControl';
import Stepper from 'views/admin/main/users/newUser/components/Stepper';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import AddQuestion from './Steps/AddQuestion';
import SelectBatch from './Steps/SelectBatch';
import Summary from './Steps/Summary';

const Index = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [isModalOpenConfirmation, setIsModalOpenConfirmation] = useState(false);

  const [testData, setTestData] = useState({
    courseId: '',
    structureId: '',
    title: '',
    type: 'mcq',
    questions: [
      {
        questionText: '',
        options: ['', '', '', ''],
        correctAnswer: '',
        marks: '',
      },
    ],
    assignedTo: [],
    courseName: '',
    completionTimeInMinutes: 60,
    // batchNumber: '',
  });

  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const steps = [
    { stepNo: 1, name: 'Course Info' },
    { stepNo: 2, name: 'Add MCQ' },
    { stepNo: 3, name: 'Summery' },
  ];
  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await testService.getAllCourses();
      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };

  const handleConfirmSubmit = () => {
    if (testData.title && testData.questions.length) {
      setIsModalOpenConfirmation(true);
    } else {
      toast.error('Please fill in all fields.');
    }
  };

  const handleSubmit = async () => {
    if (loading) return;
    if (testData.title && testData.questions.length) {
      setLoading(true);
      try {
        const { courseId, courseName, structureId, ...rest } = testData;
        const payload = {
          ...rest,
          batchStructureId: structureId,
          department: courseName,
        };
        const response = await testService.createTest(payload);
        if (response.data.success) {
          setTestData({
            courseId: '',
            structureId: '',
            title: '',
            type: 'mcq',
            questions: [
              {
                questionText: '',
                options: ['', '', '', ''],
                correctAnswer: '',
                marks: '',
              },
            ],
            assignedTo: [],
            courseName: '',
            completionTimeInMinutes: '',
            // batchNumber: '',
          });
          toast.success(response?.data?.message);
          setCurrentStep(1);
          fetchCourses();
          setIsModalOpenConfirmation(false);
          // router('/admin/read-tests');
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('Please fill in all fields.');
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <SelectBatch
            setLoading={setLoading}
            setDisable={setDisable}
            courses={courses}
            setTestData={setTestData}
            testData={testData}
            loadingCourses={loadingCourses}
          />
        );
      case 2:
        return (
          <AddQuestion
            setLoading={setLoading}
            setDisable={setDisable}
            testData={testData}
            setTestData={setTestData}
          />
        );
      case 3:
        return <Summary testData={testData} />;
      default:
        return null;
    }
  };

  const handleNext = async () => {
    if (disable) return;
    setLoading(true);
    setCurrentStep(currentStep + 1);
    setLoading(false);
  };

  const handleBack = () => {
    if (disable) return;
    setCurrentStep((cs) => cs - 1);
  };

  const handleKeyDown = (event) => {
    if (disable) return;

    if (event.key === 'Enter') {
      if (currentStep === 1) {
        handleNext();
      }
    } else if (event.key === 'ArrowLeft') {
      if (currentStep > 1) {
        handleBack();
      }
    } else if (event.key === 'ArrowRight') {
      if (currentStep < steps.length) {
        handleNext();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentStep, disable]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = (direction) => {
    let newStep = currentStep;

    direction === 'next' ? newStep++ : newStep--;
    // check if steps are within bounds
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };

  return (
    <div className="md-mt-[3] mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3  3xl:w-7/12">
        <div className="-mt-[280px] w-full pb-10 md:-mt-[340px] md:px-[70px]">
          <Stepper steps={steps} currentStep={currentStep} />
        </div>
        <Card extra={'h-full mx-auto pb-3'}>
          <div className="rounded-[20px]">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          {/* navigation button */}
          <StepperControl
            handleClick={handleClick}
            currentStep={currentStep}
            steps={steps}
            loading={loading}
            disable={disable || loading}
            handleSubmit={
              currentStep === steps.length ? handleConfirmSubmit : handleClick
            }
          />
        </Card>
      </div>
      <ConfirmationModal
        isOpen={isModalOpenConfirmation}
        onClose={() => {
          if (!loading) setIsModalOpenConfirmation(false);
        }}
        onConfirm={handleSubmit}
        title="Confirm MCQ Test Creation"
        message="Are you sure you want to create this MCQ test?"
        confirmText={loading ? 'Processing...' : 'Yes, Create MCQ Test'}
        disableConfirm={loading}
        cancelText="Cancel"
        icon="info"
      />
    </div>
  );
};

export default Index;
